<app-toast></app-toast>

<h1 class="text-3xl font-bold mobile:text-lg">{{ 'auth.onboarding_step_1.lets_get_to_know_you' | transloco}}</h1>
<p class="mt-1 mobile:text-sm">{{ 'auth.onboarding_step_1.want_to_know_you_better' | transloco}}</p>
<div class="mt-[2%] flex gap-4">
    <div class="w-16 h-16">
        <app-custom-avatar [initials]="userInitials" [imageUrl]="imagePreview"></app-custom-avatar>
    </div>
    <div class="flex flex-col gap-2">
        <div class="w-full h-[35px]">
            <app-custom-button buttonText="{{ 'auth.onboarding_step_1.upload_image' | transloco}}"
                leadingIcon="assets/icons/upload.svg" (buttonClick)="triggerFileInput()"></app-custom-button>
            <input type="file" #fileInput accept="image/png, image/jpeg" (change)="onFileSelected($event)" hidden>
        </div>
        <p class="text-sm" [ngClass]="imageValidationError ? 'text-red-500' : 'text-neutral-800'">{{
            'auth.onboarding_step_1.at_least_image_sizes' | transloco}}</p>
    </div>
</div>

<div class="max-w-screen-sm w-full self-center mt-[2vh]">
    <app-labeled-input labelText="{{ 'shared.labels.personal.first_name' | transloco}}" [inputId]="'fname'"
        [inputType]="'text'" [(inputValue)]="firstNameInput" [errorMessage]="firstNameInputError"
        placeholder="{{ 'shared.placeholders.personal.first_name' | transloco}}"
        boxHeight="h-[3vh] min-h-[50px] max-h-[70px]"></app-labeled-input>
</div>

<div class="max-w-screen-sm w-full self-center mt-1 mobile:mt-1">
    <app-labeled-input labelText="{{ 'shared.labels.personal.last_name' | transloco}}" [inputId]="'lname'"
        [inputType]="'text'" [(inputValue)]="lastNameInput" [errorMessage]="lastNameInputError"
        placeholder="{{ 'shared.placeholders.personal.last_name' | transloco}}"
        boxHeight="h-[3vh] min-h-[50px] max-h-[70px]"></app-labeled-input>
</div>

<app-custom-dropdown [options]="rolesOptions" [(selectedOption)]="selectedRole"
    label="{{ 'shared.select_role' | transloco}}" placeholder="{{ 'shared.select_role' | transloco}}"
    boxHeight="h-[3vh] min-h-[50px] max-h-[70px]" [disabled]="inviteRegister">
</app-custom-dropdown>
<div *ngIf="selectRoleShowError" class="flex items-center text-error mt-2 text-sm">
    <img src="assets/icons/close-circle.svg" alt="{{ 'shared.components.error_icon' | transloco }}" class="w-5 h-5" />
    <p class="ml-1">{{ 'shared.validators.role.required' | transloco }}</p>
</div>

<div class="max-w-screen-sm w-full self-center mt-1 mobile:mt-1">
    <app-labeled-input labelText="{{ 'shared.labels.personal.set_new_password' | transloco}}" [inputId]="'password'"
        [inputType]="'password'" [(inputValue)]="passwordInput" [errorMessage]="passwordInputError"
        (inputValueChange)="validatePasswordVisualy()"
        placeholder="{{ 'shared.placeholders.personal.set_new_password' | transloco}}"
        boxHeight="h-[3vh] min-h-[50px] max-h-[70px]" autocomplete="new-password"
        *ngIf="!socialLogin"></app-labeled-input>
</div>
<div class="flex flex-col gap-2 mt-2 text-sm" *ngIf="!socialLogin">
    <div [ngClass]="validatePasswordStatus.length ? 'text-success' : 'text-error'">
        {{ 'shared.validators.password.minLength' | transloco }}
    </div>
    <div [ngClass]="validatePasswordStatus.uppercase ? 'text-success' : 'text-error'">
        {{ 'shared.validators.password.password_rule_uppercase' | transloco }}
    </div>
    <div [ngClass]="validatePasswordStatus.lowercase ? 'text-success' : 'text-error'">
        {{ 'shared.validators.password.password_rule_lowercase' | transloco }}
    </div>
    <div [ngClass]="validatePasswordStatus.number ? 'text-success' : 'text-error'">
        {{ 'shared.validators.password.password_rule_number' | transloco }}
    </div>
    <div [ngClass]="validatePasswordStatus.special ? 'text-success' : 'text-error'">
        {{ 'shared.validators.password.password_rule_special' | transloco }}
    </div>
</div>

<div class="flex w-full justify-between mt-4 items-center">
    <div class="flex flex-col gap-1">
        <p class="font-bold text-lg text-primary mobile:text-base">{{
            'auth.onboarding_step_1.subscribe_to_product_emails' | transloco}}</p>
        <p class="font-normal text-sm text-neutral-500 mobile:text-sm">{{
            'auth.onboarding_step_1.get_the_latest_updates' | transloco}}</p>
    </div>
    <div>
        <app-toggle-button [(toggleButton)]="toggleButton"></app-toggle-button>
    </div>
</div>

<div class="flex flex-col w-full mt-8 gap-2">
    <div class="flex w-full items-center gap-3">
        <input type="checkbox" id="termsCheckbox" [(ngModel)]="termsAccepted" (change)="termsAcceptedError = false" class="w-5 h-5 cursor-pointer accent-primary flex-shrink-0"/>
        <label for="termsCheckbox" class="text-sm text-neutral-800 cursor-pointer">
            {{ 'auth.onboarding_step_1.terms.first_part' | transloco }}
            <a [href]="termsAndConditionsURL" target="_blank" class="font-bold text-primary hover:underline">
                {{ 'auth.onboarding_step_1.terms.second_part' | transloco }}
            </a>
            {{ 'auth.onboarding_step_1.terms.third_part' | transloco }}
            <a [href]="privacyPolicyURL" target="_blank" class="font-bold text-primary hover:underline">
                {{ 'auth.onboarding_step_1.terms.fourth_part' | transloco }}
            </a>
        </label>
    </div>
    <div *ngIf="termsAcceptedError" class="flex items-center text-error text-sm ml-8">
        <img src="assets/icons/close-circle.svg" alt="{{ 'shared.components.error_icon' | transloco }}" class="w-5 h-5" />
        <p class="ml-1">{{ 'shared.validators.terms.required' | transloco }}</p>
    </div>
</div>

<div class="max-w-screen-sm w-full mt-8 mb-6">
    <app-primary-button buttonText="{{ 'shared.continue' | transloco}}" [isDisabled]="continueClicked"
        (buttonClick)="continueButtonClick()">
    </app-primary-button>
</div>